import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from '@google-recaptcha/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleReCaptchaProvider 
  siteKey="6LchVcsqAAAAACllgLB3Ihr8G7TaCB1CIDbV2MNh"
  scriptProps={{
    async: true,
    defer: true,
    onLoadCallback: () => console.log("ReCaptcha Loaded"),
  }}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </GoogleReCaptchaProvider> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
